import { useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import { getAffordabilityLocalStorageItem, getLastAffordabilityCalcPage } from '@utils/localStorage';
import { ApplicantsWrapper } from '@pages/CalculatorPage/ApplicantsWrapper/ApplicantsWrapper';
import { BeforeYouStartPage } from '@pages/CalculatorPage/BeforeYouStartPage/BeforeYouStartPage';
import { FinanceDetailsPage } from '@pages/CalculatorPage/FinanceDetailsPage/FinanceDetailsPage';
import { OutgoingsPage } from '@pages/CalculatorPage/OutgoingsPage/OutgoingsPage';
import { affordabilityCalculatorFormDefaultValues } from './helpers';
import { AffordabilityCalculatorForm, CalculatorPages } from './types';
import { ResultsPage } from '@pages/CalculatorPage/ResultsPage/ResultsPage';
import { ReviewPageWrapper } from '@pages/CalculatorPage/ReviewPageWrapper';
export const CalculatorPage = () => {
  const [searchParams] = useSearchParams();
  const formSection = searchParams.get('section') as CalculatorPages;

  const savedToLocalStorageData = getAffordabilityLocalStorageItem();
  const lastFilledCalculatorPage = getLastAffordabilityCalcPage();

  const formDefaultValues = useMemo(() => {
    return savedToLocalStorageData ? savedToLocalStorageData : affordabilityCalculatorFormDefaultValues;
  }, [savedToLocalStorageData]);

  const form = useForm<AffordabilityCalculatorForm>({
    defaultValues: formDefaultValues,
    mode: 'onChange',
  });

  const ActivePage = useMemo(() => {
    if (!lastFilledCalculatorPage) return <BeforeYouStartPage />;

    switch (formSection) {
      case CalculatorPages.financeDetails:
        return <FinanceDetailsPage />;
      case CalculatorPages.applicantDetails:
        return <ApplicantsWrapper />;
      case CalculatorPages.outgoings:
        return <OutgoingsPage />;
      case CalculatorPages.reviewAnswers:
        return <ReviewPageWrapper />;
      case CalculatorPages.results:
        return <ResultsPage />;
      default:
        return <BeforeYouStartPage />;
    }
  }, [formSection, lastFilledCalculatorPage]);

  return (
    <FormProvider {...form}>
      <form>{ActivePage}</form>
    </FormProvider>
  );
};
